import { Injectable } from '@angular/core';
import { KktSumsInterface } from '@zaoblako/shared/modules/finance/dtos/kkt/kkt-activity-sums-find.dto';
import type { KktFindInterface } from '@zaoblako/shared/modules/finance/dtos/kkt/kkt-find.dto';
import type { KktFormInterface } from '@zaoblako/shared/modules/finance/dtos/kkt/kkt-form.dto';
import type { KktPageInterface } from '@zaoblako/shared/modules/finance/dtos/kkt/kkt-page.dto';
import type { KktQueryInterface } from '@zaoblako/shared/modules/finance/dtos/kkt/kkt-query.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class KktService extends BaseService {
  protected baseUrl = '/fdo/kkt';

  public findMany(queryParams?: KktQueryInterface): Observable<KktPageInterface> {
    return this.http.get<KktPageInterface>(`${this.baseUrl}/kkt`, {
      params: queryParams ? this.objectToHttpParams(queryParams) : {}
    });
  }

  public createOne(body: KktFormInterface): Observable<KktFindInterface> {
    return this.http.post<KktFindInterface>(`${this.baseUrl}/kkt`, body);
  }

  public getKktActivity(queryParams?: KktQueryInterface): Observable<KktPageInterface> {
    return this.http.get<KktPageInterface>(`${this.baseUrl}/kkt-activity`, {
      params: queryParams ? this.objectToHttpParams(queryParams) : {}
    });
  }

  public getKktActivitySums(queryParams?: KktQueryInterface): Observable<KktSumsInterface> {
    return this.http.get<KktSumsInterface>(`${this.baseUrl}/kkt-activity/sums`, {
      params: queryParams ? this.objectToHttpParams(queryParams) : {}
    });
  }
}
